const menu = {
    label: 'Perfis de Acesso',
    icon: 'pi pi-fw pi-sliders-h',
    to: '/controleacesso/perfis',
    rules: ['CTRLACS-PA-00'],
};

export default menu;
